import { HtmlExpression } from "../html-expression.interface";
import { HtmlDirective } from "./html-directive.model";


export class HtmlForLoopDirective extends HtmlDirective {
    public readonly iterator: [string, HtmlExpression];
    public readonly declarations: Record<string, HtmlExpression>;

    constructor(base: HtmlDirective, iterator: [string, HtmlExpression], declarations: Record<string, HtmlExpression>) {
        super(base.name, base.start, base.end, base.arguments, base.block)

        this.iterator = iterator;
        this.declarations = declarations;
    }
}